import './TicketInfo.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import {Badge} from "react-bootstrap";

const TicketInfoComponent = ({ticket}) => {
    if (ticket === null)
        return <></>;
    let area = ticket.area;

    console.log("TicketInfoComponent");
    console.log(ticket);
    console.log(area);
    let image = ticket.image;
    if (image === null)
        image = area.image;
    console.log(image);

    image = global.baseUrl + encodeURI(image);

    console.log(image);

    return (
        <div className="ticket-info-container">
            <div className="ticket-info-image"
                 style={{backgroundImage: `url(${image})`}}
            >
                <span className={"ticket-info-title"}>{ticket.name}</span>
                <div className={"ticket-info-content"}>
                    <div>
                        <Badge bg="dark">Area: {area.name}</Badge>
                        <Badge bg="dark">Categoria: {ticket.ticket_residence_type.name}</Badge>
                        <Badge bg="dark">Tipologia: {ticket.type}</Badge>
                    </div>
                    <div>
                        <div style={{display: "flex", justifyContent: "space-between", gap: 6}}>
                            <Badge bg="dark">Valido dal: {ticket.date_start_validity}</Badge>
                            <Badge bg="dark">Valido fino al: {ticket.date_end_validity}</Badge>
                        </div>
                        <Badge bg="dark">Prezzo: {ticket.price.toFixed(2)}€</Badge>
                        <Button variant={"success"} size="sm">Regolamento</Button>
                    </div>
                </div>
                <div className="ticket-info-bottom">
                    {/*<span>{area.address}, {area.number} {area.city} ({area.cap})</span>*/}
                    <Button variant={"success"} size="sm">Mostra più informazioni</Button>
                </div>
            </div>
        </div>
    );
};

export default TicketInfoComponent;
